/**
 * Mutable 2D scalar ({x,y}).
 */
export class Scalar2D {
  /**
   * X value.
   *
   * @type {number}
   */
  x;

  /**
   * Y value.
   *
   * @type {number}
   */
  y;
}

/**
 * Mutable 3D scalar ({x,y,z}).
 */
export class Scalar3D {
  /**
   * X value.
   *
   * @type {number}
   */
  x;

  /**
   * Y value.
   *
   * @type {number}
   */
  y;

  /**
   * Z value.
   *
   * @type {number}
   */
  z;
}